<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-column flex-sm-row justify-content-between">
          <h2 class="my-3 font-weight-bold">Nombres de Documentos</h2>
        </section>
      </v-col>
      <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pb-3">
        <v-btn
          @click="openModalUpdateOrCreateNameDocument(null)"
          :disabled="loading"
          color="primary"
          :dark="false"
          class="text-white float-right mt-4"
        >
          <i class="mdi mdi-plus me-1"></i>
          Crear Nombre de Documento
        </v-btn>
        <v-btn
          @click="openModalFilterDocumentNames()"
          :disabled="loading"
          color="primary"
          :dark="false"
          class="text-white mt-4 float-right mx-3"
        >
          <i class="mdi mdi-filter me-1"></i>
          Filtros
        </v-btn>
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-2 mt-3">
        <span class="text-primary" v-if="isPresale || isProject">
          <v-icon color="primary">
            mdi-alert-circle-outline
          </v-icon>
          IMPORTANTE: El campo de <b>Documento Cubicación</b> solo se puede
          modificar en el mantenedor general
        </span>
        <v-data-table
          :page.sync="filters.page"
          :headers="tableHeaders"
          :items="filteredNameDocuments"
          item-key="code"
          :items-per-page="filters.items"
          class="elevation-1 mt-3"
          mobile-breakpoint="993"
          hide-default-footer
          @update:sort-by="updateSortBy"
          @update:sort-desc="updateSortDesc"
          :custom-sort="customSort"
          :loading="loading"
          no-data-text="No hay Datos para Mostrar"
          loading-text="Cargando Carpetas... Espere Por favor"
        >
          <template v-slot:item.name="{ item }">
            <div class="link-text text-left">
              {{ item.document_type.name }}
            </div>
          </template>
          <template v-slot:item.assigned_area="{ item }">
            <div class="link-text text-left">
              {{
                item.document_type.assigned_area
                  ? item.document_type.assigned_area.name
                  : "-"
              }}
            </div>
          </template>
          <template v-slot:item.business_unit="{ item }">
            <div class="link-text text-left">
              {{
                getFolderDocumentType(item)
                  ? getFolderDocumentType(item).folder.business_unit.name
                  : "-"
              }}
            </div>
          </template>
          <template v-slot:item.folder_container="{ item }">
            <div class="d-flex align-items-center">
              <div>
                <p class="my-0">
                  {{
                    getFolderDocumentType(item).folder.name.length > 25
                      ? getFolderDocumentType(item).folder.name.slice(0, 25) +
                        "..."
                      : getFolderDocumentType(item).folder.name
                  }}
                </p>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="openModalSelectionFolderContainer(item)"
                    icon
                    color="success"
                    v-bind="attrs"
                    v-on="on"
                    small
                    class="mx-2"
                  >
                    <v-icon> mdi-folder-move </v-icon>
                  </v-btn>
                </template>
                <span>Cambiar Carpeta Contenedora</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.required="{ item }">
            <div class="d-flex justify-content-center">
              <v-checkbox
                @click="
                  updateRequiredAssociatedNameDocument(
                    !getFolderDocumentType(item).required,
                    item
                  )
                "
                :input-value="
                  getFolderDocumentType(item).required ? true : false
                "
              >
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.pre_project_locked="{ item }">
            <div class="d-flex justify-content-center">
              <v-checkbox
                @click="
                  updateRequiredAssociatedNameDocument(
                    !getFolderDocumentType(item).pre_project_locked,
                    item,
                    true
                  )
                "
                :input-value="
                  getFolderDocumentType(item).pre_project_locked ? true : false
                "
              >
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.is_cubicacion="{ item }">
            <div class="d-flex justify-content-center">
              <v-checkbox
                @click="
                  updateCubageAssociatedNameDocument(
                    !getFolderDocumentType(item).is_cubicacion,
                    item
                  )
                "
                :input-value="
                  getFolderDocumentType(item).is_cubicacion ? true : false
                "
                :disabled="isPresale || isProject"
              >
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.is_date_validable="{ item }">
            <div class="d-flex justify-content-center">
              <v-checkbox
                @click="
                  updateDateValidableAssociatedNameDocument(
                    !getFolderDocumentType(item).is_date_validable,
                    item
                  )
                "
                :input-value="
                  getFolderDocumentType(item).is_date_validable ? true : false
                "
                :disabled="isPresale || isProject"
              >
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex align-items-center justify-content-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="openModalUpdateOrCreateNameDocument(item)"
                    icon
                    color="warning"
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    class="mx-2"
                  >
                    <v-icon> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Editar Nombre de Documento</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="deleteNameDocument(item)"
                    icon
                    color="red darken-2"
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    class="mx-2"
                  >
                    <v-icon> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Nombre de Documento</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="filters.page"
            :length="namesDocuments ? namesDocuments.total_pages : 1"
            :total-visible="8"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <modal-selection-folder-container
      :modalAction="dialogSelectionFolderContainer"
      ref="modalSelectionFolderContainer"
      :closeModalSelectionFolderContainer="closeModalSelectionFolderContainer"
      :currentNameDocument="currentNameDocument"
      @folderSelected="getNameDocumentsData(1)"
      :isProject="isProject"
      :isPresale="isPresale"
    >
    </modal-selection-folder-container>
    <modal-update-or-create-name-document
      ref="modalUpdateOrCreateNameDocument"
      :modalAction="dialogUpdateOrCreateNameDocument"
      :closeModalCreateOrUpdateNameDocument="
        closeModalCreateOrUpdateNameDocument
      "
      :currentNameDocument="currentNameDocument"
      @nameDocumentCreatedOrUpdated="getNameDocumentsData(1)"
      :isProject="isProject"
      :isPresale="isPresale"
    >
    </modal-update-or-create-name-document>
    <filters
      :modalAction="dialogFilterDocumentNames"
      :closeModalFilterDocumentNames="closeModalFilterDocumentNames"
      @clearAllFilters="clearAllFilters"
      @searchFilters="searchFilters"
      :isProject="isProject"
      :isPresale="isPresale"
    >
    </filters>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalUpdateOrCreateNameDocument from "./ModalUpdateOrCreateNameDocument.vue";
import { authUsuarioComputed } from "@/state/helpers";
import { ACTIVE_BUSINESS_UNITS } from "@/constants/documents/maintainers";
import Filters from "./Filters.vue";
import ModalSelectionFolderContainer from "../folders/ModalSelectionFolderContainer.vue";
import { filterDeletedFolders } from "@/helpers/document";

export default {
  components: {
    ModalUpdateOrCreateNameDocument,
    Filters,
    ModalSelectionFolderContainer,
  },
  props: {
    isProject: {
      type: Boolean,
      default: false,
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyTableNamesDocuments: 1000,
      dialogUpdateOrCreateNameDocument: false,
      dialogFilterDocumentNames: false,
      dialogSelectionFolderContainer: false,
      currentNameDocument: null,
      loading: false,
      loadingActions: false,
      debounce: null,
      debounceTime: 500,
      filters: {
        page: 1,
        items: 10,
        filter: "",
        assigned_area: null,
        only_required: false,
        only_folder: true,
        only_name: true,
        business_unit: null,
        sort_by: null,
        sort_order: null,
      },
      tableHeaders: [
        {
          value: "name",
          text: "Nombre del Documento",
          sortable: true,
          width: "20%",
        },
        {
          value: "assigned_area",
          text: "Área Responsable",
          sortable: false,
          width: "15%",
          align: "left",
        },
        {
          value: "business_unit",
          text: "Unidad de Negocio",
          sortable: false,
          align: "left",
          width: "20%",
        },
        {
          value: "folder_container",
          sortable: true,
          align: "center",
          text: "Carpeta Contenedora",
          width: "20%",
        },
        {
          value: "required",
          sortable: true,
          align: "center",
          text: "Obligatorio",
          width: "10%",
        },
        {
          value: "pre_project_locked",
          sortable: false,
          align: "center",
          text: "Documento a Validar (Preventa)",
        },
        {
          value: "is_cubicacion",
          sortable: false,
          align: "center",
          text: "Documento Cubicación",
          width: "10%",
        },
        {
          value: "is_date_validable",
          sortable: false,
          align: "center",
          text: "Documento con Fecha Validable",
          width: "10%",
        },
        {
          value: "actions",
          sortable: false,
          align: "center",
          text: "Acciones",
          width: "10%",
        },
      ],
    };
  },
  mounted() {
    this.getFromBusinessUnit();
  },
  methods: {
    ...mapActions({
      getAllNamesDocuments: "document/getAllNamesDocuments",
      deleteNameDocumentService: "document/deleteNameDocument",
      updateAssociatedNameDocument: "document/updateAssociatedNameDocument",
      getAllfoldersDocuments: "document/getAllfoldersDocuments",
      disassociateNameDocumentService: "document/disassociateNameDocument",
      getDocumentsFolders: "document/getDocuments",
      getAssignedAreas: "document/getAssignedAreas",
    }),
    async getDocumentNamesFromFolder(folder) {
      this.filters.only_folder = true;
      this.filters.only_name = false;
      this.filters.filter = folder.name;
      this.getNameDocumentsData();
    },
    async getFromBusinessUnit() {
      if (this.businessUnits.length > 1) {
        this.getNameDocumentsData();
      } else {
        this.filters.business_unit = this.businessUnits.length
          ? this.businessUnits[0].code
          : null;
        if (this.filters.business_unit) {
          this.getNameDocumentsData();
        }
      }
      if (
        this.activeBusinessUnits.length == 1 ||
        this.isPresale ||
        this.isProject
      ) {
        this.getAssignedAreas({
          business_unit_filter:
            this.isPresale || this.isProject
              ? this.currentPresale.business_unit.code
              : this.activeBusinessUnits[0].code.toUpperCase(),
        });
      }
    },
    searchFilters(filters) {
      this.filters.filter = filters.filter;
      if (this.businessUnits.length > 1) {
        this.filters.business_unit = filters.business_unit;
      }
      this.filters.items = filters.items;
      this.filters.assigned_area = filters.assigned_area;
      this.filters.only_required = filters.only_required;
      this.filters.only_folder = filters.only_folder;
      this.filters.only_name = filters.only_name;
      this.getNameDocumentsData();
    },
    clearAllFilters() {
      this.filters.filter = null;
      if (this.businessUnits.length > 1) {
        this.filters.business_unit = null;
      }
      this.filters.items = 10;
      this.filters.assigned_area = null;
      this.filters.only_required = false;
      this.getNameDocumentsData();
    },
    async updateRequiredAssociatedNameDocument(
      value,
      name_document,
      updatePreProject = false
    ) {
      let payload = {
        folder_document_type_id: name_document.id,
        required: !updatePreProject
          ? value
          : updatePreProject && value
          ? true
          : name_document.required,
        pre_project_locked: updatePreProject
          ? value
          : !updatePreProject && !value
          ? false
          : name_document.pre_project_locked,
        updated_by: this.user.email,
        folder_id: name_document.folder.id,
        document_type_id: name_document.document_type.id,
      };
      const resp = await this.updateAssociatedNameDocument(payload);
      if (resp.status == 200) {
        this.$swal.fire({
          icon: "success",
          title: "Excelente",
          text: updatePreProject
            ? "Documento a validar (Preventa) actualizado correctamente"
            : "Valor obligatorio actualizado correctamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 5000,
          timerProgressBar: true,
        });
        this.getNameDocumentsData(this.filters.page);
      }
      if (!resp.status || resp.status === 400 || resp.status === 500) {
        this.loading = false;
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            resp.status == 500
              ? "Ha ocurrido un error de servidor, intenta nuevamente"
              : resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 10000,
          timerProgressBar: true,
        });
      }
    },
    async updateCubageAssociatedNameDocument(value, name_document) {
      let payload = {
        folder_document_type_id: name_document.id,
        required: name_document.required,
        pre_project_locked: name_document.pre_project_locked,
        is_cubicacion: value,
        updated_by: this.user.email,
        folder_id: name_document.folder.id,
        document_type_id: name_document.document_type.id,
      };
      const resp = await this.updateAssociatedNameDocument(payload);
      if (resp.status == 200) {
        this.$swal.fire({
          icon: "success",
          title: "Excelente",
          text: `Valor de Cubicación del Nombre de Documento actualizado correctamente`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 5000,
          timerProgressBar: true,
        });
        this.getNameDocumentsData();
      }
      if (!resp.status || resp.status === 400 || resp.status === 500) {
        this.loading = false;
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            resp.status == 500
              ? "Ha ocurrido un error de servidor, intenta nuevamente"
              : resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 10000,
          timerProgressBar: true,
        });
      }
    },
    async updateDateValidableAssociatedNameDocument(value, name_document) {
      let payload = {
        folder_document_type_id: name_document.id,
        required: name_document.required,
        pre_project_locked: name_document.pre_project_locked,
        is_cubicacion: name_document.is_cubicacion,
        is_date_validable: value,
        updated_by: this.user.email,
        folder_id: name_document.folder.id,
        document_type_id: name_document.document_type.id,
      };
      const resp = await this.updateAssociatedNameDocument(payload);
      if (resp.status == 200) {
        this.$swal.fire({
          icon: "success",
          title: "Excelente",
          text: `Fecha Validable del Nombre de Documento actualizado correctamente`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 5000,
          timerProgressBar: true,
        });
        this.getNameDocumentsData();
      }
      if (!resp.status || resp.status === 400 || resp.status === 500) {
        this.loading = false;
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            resp.status == 500
              ? "Ha ocurrido un error de servidor, intenta nuevamente"
              : resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 10000,
          timerProgressBar: true,
        });
      }
    },
    async getNameDocumentsData(page = 1) {
      clearTimeout(this.debounce);
      let self = this;
      this.debounce = await setTimeout(async function() {
        self.loading = true;
        self.filters.page = page;
        await self.getAllNamesDocuments({
          ...self.filters,
          filter:
            self.filters.only_folder && self.filters.only_name
              ? self.filters.filter
              : undefined,
          folder_filter:
            self.filters.only_folder && !self.filters.only_name
              ? self.filters.filter
              : undefined,
          name_filter:
            self.filters.only_name && !self.filters.only_folder
              ? self.filters.filter
              : undefined,
          business_unit_filter:
            self.isPresale || self.isProject
              ? self.currentPresale.business_unit.code
              : self.filters.business_unit,
          required_filter: self.filters.only_required,
          project_id: self.isProject ? self.currentProject.id : undefined,
          pre_project_id: self.isPresale
            ? self.$route.query.presale_code
            : undefined,
          assigned_area_id: self.filters.assigned_area,
          sort_by: self.filters.sort_by ? self.filters.sort_by : undefined,
          sort_order: self.filters.sort_order
            ? self.filters.sort_order
            : undefined,
        });
        self.keyTableNamesDocuments = self.keyTableNamesDocuments + 1;
        self.loading = false;
      }, self.debounceTime);
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by = sortBy == "folder_container" ? "folder" : sortBy;
        this.filters.sort_order = "asc";
        await this.getNameDocumentsData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getNameDocumentsData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getNameDocumentsData();
      }
    },
    customSort(items, index, isDesc, column) {
      return items;
    },
    openModalUpdateOrCreateNameDocument(document) {
      this.currentNameDocument = document;
      this.$refs.modalUpdateOrCreateNameDocument.setBusinessUnitUser();
      this.dialogUpdateOrCreateNameDocument = true;
    },
    closeModalCreateOrUpdateNameDocument() {
      this.currentNameDocument = null;
      this.dialogUpdateOrCreateNameDocument = false;
    },
    openModalFilterDocumentNames() {
      this.dialogFilterDocumentNames = true;
    },
    closeModalFilterDocumentNames() {
      this.dialogFilterDocumentNames = false;
    },
    async openModalSelectionFolderContainer(nameDocument) {
      this.currentNameDocument = nameDocument;
      this.dialogSelectionFolderContainer = true;
      let foldersTreeViewMaintainer = await this.getDocumentsFolders({
        business_unit_filter: nameDocument.folder.business_unit.name,
        project_code: this.isProject
          ? this.getCodeProjectFromParamsOrQuery
          : undefined,
        pre_project_code: this.isPresale
          ? this.$route.params.codePresale
          : undefined,
        not_committed: true,
      });
      this.$refs.modalSelectionFolderContainer.setFoldersToSelect(
        filterDeletedFolders(foldersTreeViewMaintainer),
        true
      );
    },
    closeModalSelectionFolderContainer() {
      this.currentNameDocument = null;
      this.dialogSelectionFolderContainer = false;
    },
    async deleteNameDocument(name_document) {
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title:
            "¿Estás seguro de eliminar el nombre de documento: " +
            "<b>" +
            name_document.document_type.name +
            "</b>" +
            "?",
          text: "Esta acción no se puede deshacer",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "red",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            this.loadingActions = true;
            let resp = null;
            if (name_document.folder) {
              resp = await this.disassociateNameDocumentService({
                document_type_id: name_document.document_type.id,
                folder_id: name_document.folder.id,
              });
            }
            if (resp?.status == 200 || !name_document.folder) {
              if (!self.isProject && !self.isPresale) {
                resp = await this.deleteNameDocumentService({
                  type_id: name_document.document_type.id,
                });
              }
              if (resp.status == 200) {
                this.$swal.fire({
                  icon: "success",
                  title: "Excelente",
                  text:
                    "El Nombre de Documento: " +
                    name_document.document_type.name +
                    " ha sido eliminado",
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 5000,
                  timerProgressBar: true,
                });
                self.$emit("nameDocumentDeleted");
                self.getNameDocumentsData();
              }
              if (!resp.status || resp.status === 400) {
                this.loading = false;
                return this.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: resp.data.detail,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 10000,
                  timerProgressBar: true,
                });
              }
            }
            if (!resp.status || resp.status === 400) {
              this.loading = false;
              return this.$swal.fire({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 10000,
                timerProgressBar: true,
              });
            }
            this.loadingActions = false;
          }
        });
    },
    getFolderDocumentType(item) {
      return item;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      namesDocuments: "document/namesDocuments",
      foldersDocumentsFromBusinessUnit:
        "document/foldersDocumentsFromBusinessUnit",
      businessUnits: "document/businessUnits",
      currentProject: "project/currentProject",
      foldersDocuments: "document/foldersDocuments",
      currentPresale: "presale/presale",
    }),
    wrappedTableHeaders() {
      if (this.isProject) {
        return this.tableHeaders.filter(
          (item) => item.value != "pre_project_locked"
        );
      }
      return this.tableHeaders;
    },
    activeBusinessUnits() {
      return this.businessUnits.filter((item) =>
        ACTIVE_BUSINESS_UNITS.includes(item.name)
      );
    },
    filteredNameDocuments() {
      return this.namesDocuments.items;
    },
    getCodeProjectFromParamsOrQuery(){
      return this.$route.params.codigoProyecto || this.$route.query.code  
    }
  },
  watch: {
    "filters.page": function(page) {
      this.getNameDocumentsData(page);
    },
  },
};
</script>

<style></style>